export const TAGE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
export const TAGE_LANG = [
    'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag',
];
export const STUNDEN = Array.from({ length: 16 }, (_, i) => i + 7); // 07–22 Uhr
export const TYP_LABEL = {
    training: 'Training',
    spiel: 'Spiel',
    event: 'Event',
};
/** "18:30" → 18.5 */
export function parseTime(hhmm) {
    const [h, m] = hhmm.split(':').map(Number);
    return (h || 0) + (m || 0) / 60;
}
/** 18.5 → "18:30" */
export function formatTime(dezimal) {
    const h = Math.floor(dezimal);
    const m = Math.round((dezimal - h) * 60);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
/**
 * Client-seitige Konflikt-Vorschau (gleiche Logik wie der Server).
 * Maßgeblich bleibt immer die Serverprüfung beim Speichern.
 */
export function findeKonflikte(belegungen) {
    const treffer = new Set();
    // Ausgefallene Termine erzeugen keine Konflikte
    const aktiv = belegungen.filter((b) => b._status !== 'entfaellt');
    for (let i = 0; i < aktiv.length; i++) {
        for (let j = i + 1; j < aktiv.length; j++) {
            if (kollidiert(aktiv[i], aktiv[j])) {
                treffer.add(aktiv[i].id);
                treffer.add(aktiv[j].id);
            }
        }
    }
    return treffer;
}
function kollidiert(a, b) {
    if (a.platz_id !== b.platz_id) {
        return false;
    }
    // Zeitüberlappung
    const aS = parseTime(a.start_zeit), aE = parseTime(a.end_zeit);
    const bS = parseTime(b.start_zeit), bE = parseTime(b.end_zeit);
    if (aS >= bE || bS >= aE) {
        return false;
    }
    return zeitbezugUeberlappt(a, b);
}
function zeitbezugUeberlappt(a, b) {
    if (a.wiederkehrend && b.wiederkehrend) {
        if (a.wochentag !== b.wochentag) {
            return false;
        }
        return saisonUeberlappt(a, b);
    }
    if (!a.wiederkehrend && !b.wiederkehrend) {
        return !!a.datum && a.datum === b.datum;
    }
    const serie = a.wiederkehrend ? a : b;
    const einzel = a.wiederkehrend ? b : a;
    if (!einzel.datum) {
        return false;
    }
    const wt = new Date(einzel.datum).getDay(); // 0=So
    const wtIso = wt === 0 ? 7 : wt;
    if (wtIso !== serie.wochentag) {
        return false;
    }
    const start = serie.saison_start || '1970-01-01';
    const ende = serie.saison_ende || '2999-12-31';
    return einzel.datum >= start && einzel.datum <= ende;
}
function saisonUeberlappt(a, b) {
    const aStart = a.saison_start || '1970-01-01';
    const aEnde = a.saison_ende || '2999-12-31';
    const bStart = b.saison_start || '1970-01-01';
    const bEnde = b.saison_ende || '2999-12-31';
    return aStart <= bEnde && bStart <= aEnde;
}
/**
 * Rollt Sperren auf konkrete Termine einer Woche aus.
 * Jede ausgerollte Sperre erhält `_occ_datum` und einen `wochentag`.
 */
export function expandiereSperrenWoche(sperren, montag) {
    const wochenStart = toISODate(montag);
    const wochenEnde = toISODate(addTage(montag, 6));
    const ergebnis = [];
    for (const s of sperren) {
        if (s.wiederkehrend) {
            const iso = toISODate(datumImWochentag(montag, s.wochentag || 1));
            const start = s.saison_start || '1970-01-01';
            const ende = s.saison_ende || '2999-12-31';
            if (iso >= start && iso <= ende) {
                ergebnis.push({ ...s, _occ_datum: iso });
            }
        }
        else if (s.datum && s.datum >= wochenStart && s.datum <= wochenEnde) {
            const wt = new Date(s.datum).getDay();
            ergebnis.push({ ...s, wochentag: wt === 0 ? 7 : wt, _occ_datum: s.datum });
        }
    }
    return ergebnis;
}
/**
 * Client-Vorschau: blockiert eine Sperre die geplante Belegung?
 * (Maßgeblich bleibt die Serverprüfung.)
 */
export function findeSperre(belegung, sperren) {
    const bS = parseTime(belegung.start_zeit);
    const bE = parseTime(belegung.end_zeit);
    return sperren.find((s) => {
        if (s.platz_id !== belegung.platz_id) {
            return false;
        }
        // Zeitfenster (ganztägig blockiert immer)
        if (!s.ganztags && s.start_zeit && s.end_zeit) {
            const sS = parseTime(s.start_zeit);
            const sE = parseTime(s.end_zeit);
            if (!(sS < bE && bS < sE)) {
                return false;
            }
        }
        return zeitbezugUeberlappt(belegung, s);
    });
}
// ── Datums-/Wochenlogik ─────────────────────────────────────────────────────
/** Lokales "YYYY-MM-DD" (ohne UTC-Verschiebung). */
export function toISODate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const t = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${t}`;
}
/** Montag der Woche, in der das Datum liegt (00:00 lokal). */
export function montagDerWoche(datum) {
    const d = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate());
    const wt = d.getDay() === 0 ? 7 : d.getDay(); // 1=Mo … 7=So
    d.setDate(d.getDate() - (wt - 1));
    return d;
}
export function addTage(d, n) {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
}
/** Datum für einen Wochentag (1=Mo…7=So) innerhalb einer Montags-Woche. */
export function datumImWochentag(montag, wochentag) {
    return addTage(montag, wochentag - 1);
}
/** Formatiert eine Woche als "16.–22. Juni 2026". */
export function wochenLabel(montag) {
    const sonntag = addTage(montag, 6);
    const monate = [
        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
    ];
    const m1 = montag.getMonth();
    const m2 = sonntag.getMonth();
    if (m1 === m2) {
        return `${montag.getDate()}.–${sonntag.getDate()}. ${monate[m2]} ${sonntag.getFullYear()}`;
    }
    return `${montag.getDate()}. ${monate[m1]} – ${sonntag.getDate()}. ${monate[m2]} ${sonntag.getFullYear()}`;
}
/**
 * Erweitert eine Belegungsliste auf konkrete Termine einer Kalenderwoche
 * und wendet dabei Ausnahmen einzelner Serientermine an.
 *
 * - Einzeltermine: erscheinen, wenn ihr Datum in der Woche liegt.
 * - Serien: erscheinen am passenden Wochentag innerhalb der Saison-Spanne.
 *   - Ausnahme 'entfaellt' → Vorkommen wird mit _status:'entfaellt' markiert
 *     (für die Anzeige als „Entfällt", nicht herausgefiltert).
 *   - Ausnahme 'geaendert' → Override-Felder werden angewandt.
 *
 * Jedes Vorkommen erhält `datum`, `_occ_datum` und `_status`.
 */
export function expandiereWoche(belegungen, montag, ausnahmen = [], schliesszeiten = []) {
    const wochenStart = toISODate(montag);
    const wochenEnde = toISODate(addTage(montag, 6));
    const ergebnis = [];
    // Ausnahmen indizieren: belegung_id + datum → Ausnahme
    const ausnahmeFuer = (belegungId, datum) => ausnahmen.find((a) => a.belegung_id === belegungId && a.datum === datum);
    for (const b of belegungen) {
        if (b.wiederkehrend) {
            const tagDatum = datumImWochentag(montag, b.wochentag || 1);
            const iso = toISODate(tagDatum);
            const start = b.saison_start || '1970-01-01';
            const ende = b.saison_ende || '2999-12-31';
            if (iso < start || iso > ende) {
                continue;
            }
            const ausnahme = ausnahmeFuer(b.id, iso);
            const occ = {
                ...b,
                datum: iso,
                _occ_datum: iso,
                _status: 'normal',
            };
            if (ausnahme) {
                occ._ausnahme_id = ausnahme.id;
                if (ausnahme.status === 'entfaellt') {
                    occ._status = 'entfaellt';
                }
                else {
                    occ._status = 'geaendert';
                    if (ausnahme.platz_id != null)
                        occ.platz_id = ausnahme.platz_id;
                    if (ausnahme.team_id != null)
                        occ.team_id = ausnahme.team_id;
                    if (ausnahme.titel != null)
                        occ.titel = ausnahme.titel;
                    if (ausnahme.typ != null)
                        occ.typ = ausnahme.typ;
                    if (ausnahme.start_zeit != null)
                        occ.start_zeit = ausnahme.start_zeit;
                    if (ausnahme.end_zeit != null)
                        occ.end_zeit = ausnahme.end_zeit;
                    if (ausnahme.notiz != null)
                        occ.notiz = ausnahme.notiz;
                }
            }
            // Schließtag/Feiertag hat Vorrang: Termin entfällt
            if (schliesstAm(iso, schliesszeiten)) {
                occ._status = 'entfaellt';
            }
            ergebnis.push(occ);
        }
        else if (b.datum && b.datum >= wochenStart && b.datum <= wochenEnde) {
            const wt = new Date(b.datum).getDay();
            ergebnis.push({
                ...b,
                wochentag: wt === 0 ? 7 : wt,
                _occ_datum: b.datum,
                _status: schliesstAm(b.datum, schliesszeiten) ? 'entfaellt' : 'normal',
            });
        }
    }
    return ergebnis;
}
/** Prüft, ob ein Datum (Y-M-D) auf einen Schließtag fällt. */
/** Prüft, ob ein Datum (Y-M-D) auf einen Schließtag fällt. */
export function schliesstAm(datum, liste) {
    if (!liste || liste.length === 0) {
        return false;
    }
    const monat = Number(datum.slice(5, 7));
    const tag = Number(datum.slice(8, 10));
    return liste.some((s) => {
        if (s.monat != null && s.tag != null) {
            return s.monat === monat && s.tag === tag;
        }
        if (s.datum) {
            const bis = s.datum_bis || s.datum;
            return datum >= s.datum && datum <= bis;
        }
        return false;
    });
}
/** Ressourcen-Kategorien (Plätze, Räume, Geräte …). */
export const KATEGORIEN = [
    { wert: 'platz', label: 'Platz / Feld', kurz: 'Platz' },
    { wert: 'raum', label: 'Raum', kurz: 'Raum' },
    { wert: 'geraet', label: 'Gerät', kurz: 'Gerät' },
    { wert: 'sonstiges', label: 'Sonstiges', kurz: 'Sonst.' },
];
export const kategorieLabel = (k) => KATEGORIEN.find((x) => x.wert === (k || 'platz'))?.label ?? 'Platz / Feld';
export const kategorieKurz = (k) => KATEGORIEN.find((x) => x.wert === (k || 'platz'))?.kurz ?? 'Platz';
